import { Channel, Topic } from "../constants/index.js";
import { useCallback, useEffect } from "react";
import { MessageBrokerUtils } from "../utils/index.js";
import { RealityCheckActionCreators } from "../redux/action-creators/index.js";
import { useDispatch, useSelector } from "react-redux";
import { UserContextSelectors } from "../redux/selectors/index.js";
import { useFeature } from "./useFeature.js";
import { AppFeatures } from "../constants/featureFlags.js";

export const useSportSessionDetails = () => {
  const dispatch = useDispatch();
  const brandID = useSelector(UserContextSelectors.brandId);
  const getSessionTimeWithCustomActivationEnabled = useFeature(
    AppFeatures.GET_SESSION_TIME_WITH_CUSTOM_ACTIVATION
  );

  const handleSportSessionDetails = useCallback(
    sportSessionDetails => {
      dispatch(
        RealityCheckActionCreators.setSportSessionDetails(sportSessionDetails)
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, brandID, getSessionTimeWithCustomActivationEnabled]
  );

  useEffect(() => {
    const handleSportSessionDetailsSubscription = MessageBrokerUtils.subscribe({
      channel: Channel.SESSION,
      topic: Topic.sportSessionDetails,
      callback: handleSportSessionDetails
    });

    return () => {
      handleSportSessionDetailsSubscription?.unsubscribe();
    };
  }, [handleSportSessionDetails]);
};
